// ABOUTME: Components used by the ORDER_STATE grouping preset — ShLabel pill keyed by t(state).
// ABOUTME: The registry entry that references these lives in groupingPresets/index.js.

import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import ShLabel from "../../label/ShLabel";
import { getOrderStateData } from "../../../../utils/labelColorText";


export const OrderStateLabel = ({ groupKey }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { labelcolor, labeltext } = getOrderStateData(groupKey, theme);
    return (
        <ShLabel fitted size={32} palette="normal" variant={labelcolor}>
            {t(labeltext)}
        </ShLabel>
    );
};

export const OrderStatePreview = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <ShLabel size={32} palette="normal" variant={theme.palette.mode === "dark" ? "blue" : "primary"}>
            {t("processing")}
        </ShLabel>
    );
};
